<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Select Payment Method
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div
      v-if="loading"
      class="ac-loading-container"
    >
      <img
        src="@shared/assets/img/general/loading.svg"
        class="loading-payments"
        alt="Loading"
      >
    </div>
    <div
      v-else
      class="ac-body-container"
    >
      <PaymentMethodItem
        v-for="pm in paymentMethods"
        :key="pm.id"
        :selected="paymentMethod.id === pm.id"
        :paymentMethod="pm"
        :onSelect="handleSelect"
      />
      <button
        type="button"
        class="add-button"
        @click="toggleActionModal(true, 'new-payment-method')"
      >
        + Add New Payment Method
      </button>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-cancel-button margin-right-4"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ac-form-button"
        @click="handleConfirm"
      >
        Confirm
      </button>
    </div>
  </div>
</template>

<script>
import apiClient from '@shared/lib/general/apiClient';
import PaymentMethodItem from './PaymentMethodItem.vue';

export default {
  name: 'AllPaymentMethods',
  components: {
    PaymentMethodItem,
  },
  props: {
    corpId: Number,
    selectedPaymentMethod: Object,
    toggleActionModal: Function,
    onSubmit: Function,
    changes: Function,
  },
  data() {
    return {
      paymentMethods: [],
      paymentMethod: this.selectedPaymentMethod,
      loading: true,
    };
  },
  mounted() {
    this.getAllPaymentMethods();
  },
  methods: {
    async getAllPaymentMethods() {
      this.loading = true;
      const { data } = await apiClient({
        method: 'GET',
        url: `/chargebee/corporation/${this.corpId}/payment-method/all`,
      });
      this.paymentMethods = data;
      this.loading = false;
    },
    async handleConfirm() {
      this.changes([{
        field: 'selectedPaymentMethod',
        value: this.paymentMethod,
      }]);
      if (this.onSubmit) {
        await this.onSubmit();
      }
      this.toggleActionModal(false);
    },
    handleSelect(pm) {
      this.paymentMethod = pm;
    },
  },
};
</script>

<style lang="scss" scoped>

.add-button {
  width: 100%;
  background-color: $NBLUE100;
  height: 48px;
  border-radius: 8px;
  color: $WHITE;
  font-weight: 500;
  font-size: 1.125rem;
}

.ac-loading-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .loading-payments {
    width: 40px;
    height: 40px;
  }
}
</style>
